/**
 * QA environment configuration
 */
import type { Config } from './default';

const config: Partial<Config> = {
  descope: {
    // QA environment
    pharmacyPortal: {
      flowId: 'sign-in-developers-lower-environment-portals',
      tenant: 'smithrx-internal',
    },
    projectId: 'P2nTygif6azB2k1YQnvWdilC4THa',
  },
  statsig: {
    // Client-side SDK key for development environment
    sdkKey: 'client-CEVqp32NixFG4IrlVFy8mrgNwWex1bkCTEYxMZdFp5S',
    environment: 'staging',
  },
  isProduction: false,
};

export default config;
